import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconCup"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H16.25C16.6642 3 17 3.33579 17 3.75V6H18.25C19.7688 6 21 7.23122 21 8.75V10.25C21 11.7688 19.7688 13 18.25 13H17V18.25C17 19.7688 15.7688 21 14.25 21H5.75C4.23122 21 3 19.7688 3 18.25V3.75ZM17 11.5H18.25C18.9404 11.5 19.5 10.9404 19.5 10.25V8.75C19.5 8.05964 18.9404 7.5 18.25 7.5H17V11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCup;
